<p-table
    [autoLayout]="true"
    [value]="tableData"
    (onSort)="customSort($event)"
    [sortField]="defaultSortField"
    [sortOrder]="defaultSortOrder"
    [lazy]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <ng-container *ngFor="let header of [
          { dataName: 'user', columnName: 'Completed By', sortable: false, alwaysShow: true },
          { dataName: 'site', columnName: 'Site', sortable: false },
          { dataName: 'asset', columnName: 'Asset', sortable: false },
          { dataName: 'workOrder', columnName: 'Work Order', sortable: false },
          { dataName: 'createdDate', columnName: 'Date Completed', sortable: true },
          { dataName: 'version', columnName: 'Version', sortable: false }
      ]">
        <th *ngIf="header.alwaysShow || tableOptions.visibleColumns.includes(header.columnName)" [pSortableColumn]="header.sortable ? (header.sortDataName ? header.sortDataName : header.dataName) : false">
          {{header.columnName}}
          <p-sortIcon *ngIf="header.sortable" [field]="header.sortDataName ? header.sortDataName : header.dataName"></p-sortIcon>
        </th>
      </ng-container>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{ row.user.fullName }}</td>
      <td *ngIf="tableOptions.visibleColumns.includes('Site')">{{ row.site ? row.site.name : 'N/A' }}</td>
      <td *ngIf="tableOptions.visibleColumns.includes('Asset')">{{ row.asset ? row.asset.name : 'N/A'}}</td>
      <td *ngIf="tableOptions.visibleColumns.includes('Work Order')">
        <ng-container *ngIf="row.workOrder">
          <a [routerLink]="['/', routeRole, 'sites', row.site.id, 'work-orders', row.workOrder.id]">{{'WRK ' + row.workOrder.id}}</a>
        </ng-container>
        <ng-container *ngIf="!row.workOrder">
          N/A
        </ng-container>
      </td>
      <td *ngIf="tableOptions.visibleColumns.includes('Date Completed')"> <date-friendly [value]="row.createdDate"></date-friendly> </td>
      <td *ngIf="tableOptions.visibleColumns.includes('Version')">{{ row.form.version }}</td>
      <td> <a [routerLink]="['response', row.id]">view</a> </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="7">No form responses found</td>
    </tr>
  </ng-template>
</p-table>

<div class="card-footer">
  <p-paginator
    #paginator
    [rows]="pagination.size"
    [totalRecords]="pagination.totalRecords"
    [rowsPerPageOptions]="pageSizes"
    (onPageChange)="paginate($event)">
  </p-paginator>
</div>

